(function(){
    'use strict'

    angular.module('app.archivoCCSS')
    .factory('ArchivoCCSSService', ArchivoCCSSService);

    ArchivoCCSSService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function ArchivoCCSSService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getTiposJornada: getTiposJornada,
            getTiposSeguro: getTiposSeguro,
            getTiposCambio: getTiposCambio,
            getTiposIncapacidad: getTiposIncapacidad,
            getTiposPension: getTiposPension,
            getTiposPermiso: getTiposPermiso,
            getArchivoGrandesContribuyentes: getArchivoGrandesContribuyentes,
            getById: getById,
            save: save,
            update: update,
            remove: remove
        };

        return api;

        function getAll(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivo-ccss/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function getTiposJornada(){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/tipos-jornada';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getTiposSeguro(){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/tipos-seguro';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getTiposCambio(){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/tipos-cambio';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getTiposIncapacidad(){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/tipos-incapacidad';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getTiposPension(){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/tipos-pension';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getTiposPermiso(){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/tipos-permiso';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getArchivoGrandesContribuyentes(anno, mes){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/generar-grandes-contribuyentes/' + UserInfoService.getCompaniaId() + '/' + anno + '/' + mes;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getById(registroId){

            var url = apiSettings.apiBaseUrl + 'api/archivo-ccss/' + UserInfoService.getCompaniaId() + '/' + registroId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(registro){

            registro.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivo-ccss',  
                method: 'POST',  
                data: registro
            });  
            return response;
        };

        function update(registro){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivo-ccss',  
                method: 'PUT',  
                data: registro
            });  
            return response;
        };

        function remove(registro){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivo-ccss',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: registro
            });  
            return response;
        };

    };

})();